import { configureStore } from '@reduxjs/toolkit'
import reservationReducer from './reservationSlice'

export const store = configureStore({
  reducer: { reservationSlice: reservationReducer },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false })
})

export type RootState = ReturnType<typeof store.getState>
